import { useState, useEffect } from "react";

const useIsMobileGrid = () => {
  const [isGrid, setIsGrid] = useState(window.innerWidth <= 900);

  useEffect(() => {
    const onResize = () => setIsGrid(window.innerWidth <= 900);
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  return isGrid;
};

export default useIsMobileGrid;
